export function initialFrame(options) {
  const shouldUseFrom = options.namedEffect && (options.fill === 'backwards' || options.fill === 'both') && !options.reversed;
  return shouldUseFrom ? {
    opacity: 0
  } : {
    opacity: 'var(--comp-opacity, 1)'
  };
}
//# sourceMappingURL=common.js.map